var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-row',_vm._g(_vm._b({ref:"head",style:({ color: '#41464b' }),attrs:{"row":_vm.row}},'dx-row',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }